'use strict';

var aviaryColors = require('../../../../../../../../../_virtual/aviaryColors.cjs');

var hasRequiredAviaryColors;

function requireAviaryColors () {
	if (hasRequiredAviaryColors) return aviaryColors.__exports;
	hasRequiredAviaryColors = 1;

	var AVIARY_COLORS = /*#__PURE__*/ function(AVIARY_COLORS) {
	    AVIARY_COLORS["primary"] = "primary";
	    AVIARY_COLORS["info"] = "info";
	    AVIARY_COLORS["warning"] = "warning";
	    AVIARY_COLORS["danger"] = "danger";
	    AVIARY_COLORS["highlight"] = "highlight";
	    AVIARY_COLORS["system"] = "system";
	    AVIARY_COLORS["success"] = "success";
	    return AVIARY_COLORS;
	}({});

	aviaryColors.__exports.AVIARY_COLORS = AVIARY_COLORS;
	
	return aviaryColors.__exports;
}

exports.__require = requireAviaryColors;
//# sourceMappingURL=aviaryColors.cjs.map
